// extracted by mini-css-extract-plugin
export default {"results":"PriceFilter__results--sAhK6","priceRange":"PriceFilter__priceRange--gzuM3"};